import React from 'react';

import { Button } from '@BICE_Vida/components';

import { Modal, ModalBody, ModalContent } from '@BICE_Vida/scp-components';

import { CAT } from '@/utils/assets';

import styles from './PreexistingConditionsModal.module.scss';
import { preexistingConditionsHeaderText } from '@/utils/generalTexts';
import { trackClick, clickActionsEvents } from '@/utils/dataLayer/home';

type PreexistingConditionsModalT = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  availablePlans: number;
};

function PreexistingConditionsModal({
  isOpen,
  setIsOpen,
  availablePlans,
}: PreexistingConditionsModalT) {
  const onClickFunction = () => setIsOpen(!isOpen);

  const onClickLink = () => {
    trackClick({
      action: clickActionsEvents.btnPreexistingConditionsModal,
    });
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onClose={onClickFunction}
        closeOnOverlay
        classNameModal={styles.preexisting_conditions_modal}
      >
        <div>
          <ModalBody
            img={CAT.CAT_THINKING_ROUND}
            className={styles.preexisting_conditions_modal_body}
            content={
              <ModalContent
                title={preexistingConditionsHeaderText.modal.title}
                className={styles.preexisting_conditions_text_modal_content}
              >
                <div className={styles.preexisting_conditions_text_modal_body}>
                  {preexistingConditionsHeaderText.modal.content(availablePlans)}
                </div>
                <div className={styles.preexisting_conditions_text_modal_footer}>
                  {preexistingConditionsHeaderText.modal.footer(onClickLink)}
                </div>
              </ModalContent>
            }
          />
        </div>
        <div className={styles.preexisting_conditions_container_buttons}>
          <Button
            text="Entendido"
            variant="primary"
            size="large"
            onClick={onClickFunction}
            className={styles.button_text}
          />
        </div>
      </Modal>
    </div>
  );
}

export default PreexistingConditionsModal;
